import api from '../plugins/axios';

function handleError(error, blockMessage = '') {
  console.error(blockMessage, error);
}

export default {
  state: {
    values: [],
    orgChart: {},
    pointsGranted: 0,
    engagement: [],
    pointsSpent: 0,
    popularRewards: [],
    activeUsers: 0,
    commonTopics: [],
  },
  actions: {
    async loadValues({ commit, rootState }) {
      try {
        const { data } = await api.get('/leaderboards/values');
        let valuesData = [];
        if (data.length) {
          let roundedShares = 0;
          data.map((data) => {
            const value = rootState.auth.values.find((value) => value.id === data.value_id);
            roundedShares += data.share;
            valuesData.push({ ...value, ...data });
          });
          valuesData[0].share += roundedShares > 100 ? -roundedShares % 100 : 100 % roundedShares;
        } else {
          valuesData = rootState.auth.values.map((value) => ({ ...value, share: 0 })).slice(0, 10);
        }

        commit('setValues', valuesData);
      } catch (e) {
        handleError(e, 'Error load Leaderboard: ');
      }
    },
    async loadOrgChart({ commit }) {
      try {
        const { data } = await api.get('/leaderboards/org_chart');
        commit('setOrgChart', data);
      } catch (e) {
        handleError(e, 'Error load Leaderboard: ');
      }
    },
    async loadCommonTopics({ commit }) {
      try {
        const { data } = await api.get('/leaderboards/common_topics');
        commit('setCommonTopics', data);
      } catch (e) {
        handleError(e, 'Error load common topics: ');
      }
    },
    async loadStatistics({ commit }) {
      try {
        const { data } = await api.get('/leaderboards/statistics');

        if (data.engagement.length) {
          const sortedData = data.engagement.sort((a, b) => new Date(a[0]).getTime() - new Date(b[0]).getTime());
          const engagementWithTimestamps = sortedData.map((entry) => [new Date(entry[0]).getTime(), entry[1]]);

          commit('setEngagement', engagementWithTimestamps);
        }
        if (data.points_granted) {
          commit('setPointsGranted', data.points_granted);
        }
        if (data.points_spent) {
          commit('setPointsSpent', data.points_spent);
        }

        if (data.purcheses_counts && data.rewards?.length) {
          const popularRewards = data.rewards.map((reward) => ({
            ...reward,
            purchase_count: data.purcheses_counts[reward.id] || 0,
          }));

          const topFiveRewards = popularRewards.sort((a, b) => b.purchase_count - a.purchase_count).slice(0, 5);
          commit('setPopularRewards', topFiveRewards);
        }
        commit('setActiveUsers', data.active_users);
      } catch (e) {
        handleError(e, 'Error load Leaderboard: ');
      }
    },
  },
  mutations: {
    setValues(state, value) {
      state.values = value;
    },
    setOrgChart(state, value) {
      state.orgChart = value;
    },
    setCommonTopics(state, value) {
      state.commonTopics = value;
    },
    setPointsGranted(state, value) {
      state.pointsGranted = value;
    },
    setPointsSpent(state, value) {
      state.pointsSpent = value;
    },
    setEngagement(state, value) {
      state.engagement = value;
    },
    setPopularRewards(state, value) {
      state.popularRewards = value;
    },
    setActiveUsers(state, value) {
      state.activeUsers = value;
    },
    resetData(state) {
      state.values = [];
      state.orgChart = {};
      state.pointsGranted = 0;
      state.engagement = [];
      state.pointsSpent = 0;
      state.popularRewards = [];
    },
  },
  namespaced: true,
};
